import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TableModule } from '../table/table.module';
import { TelusCommonModule } from '../common/common.module';
import { TelusFormModule } from '../form/form.module';
import { TranslocoRootModule } from '@telus/d2c-core/i18n/transloco-root.module';
import { TableConfigService } from '@telus/d2c-core';
import { OverviewDetailSectionComponent } from './overview-details-section/overview-details-section.component';
import { InsightsDetailsSectionComponent } from './insights-details-section/insights-section.component';
import { TelusAssignVendorSalesRepModalComponent } from './telus-assign-vendor-sales-rep/telus-assign-vendor-sales-rep-modal.component';

const assembledComponentsList = [
  OverviewDetailSectionComponent,
  InsightsDetailsSectionComponent,
  TelusAssignVendorSalesRepModalComponent,
];

@NgModule({
  imports: [
    IonicModule.forRoot(),
    CommonModule,
    FormsModule,
    TableModule,
    TelusFormModule,
    TranslocoRootModule,
    TelusCommonModule,
  ],
  providers: [DatePipe, TableConfigService],
  declarations: assembledComponentsList,
  exports: assembledComponentsList,
})
export class TelusAssembledComponentsModule {}
